module.exports = __webpack_public_path__ + "img/0-103.24b22f79.jpg";